module.exports = __webpack_public_path__ + "img/in-person-dark.f9274512.svg";